import { Fragment } from 'react';
import styled from 'styled-components';
import { useDispatch } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import { ButtonBase, Grid, Tooltip } from '@material-ui/core';
import NotesModal from '../Modals/NotesModal';
import { modalsToggle } from '../../actions';
import FormattedAmount from 'components/FormattedAmount';

import infoIcon from '../../img/info.svg';
import greyInfoIcon from '../../img/info_gray.svg';
import successInfoIcon from '../../img/info_success.svg';

const styles = () => ({
  tooltip: {
    backgroundColor: '#ffffff',
    color: '#616161',
    fontSize: 14,
    opacity: 1
  },
  popper: {
    backgroundColor: '#ffffff',
    opacity: 1,
    wordBreak: 'break-word',
    boxShadow: '0px 5px 5px -3px rgb(0 0 0 / 20%), 0px 8px 10px 1px rgb(0 0 0 / 14%), 0px 3px 14px 2px rgb(0 0 0 / 12%)'
  }
});

const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const StyledInfoButton = styled(ButtonBase)`
  span {
    font-size: 18px;
  }
`;

const StyledGridContainer = styled(Grid)`
  max-width: 400px;
  padding: 6px;
`;

const StyledGridItemLabel = styled(Grid)`
  color: #616161;
  padding: 4px 8px;
`;

const StyledGridItem = styled(Grid)`
  color: #757575;
  padding: 4px 8px;
`;

const createOtherOfferInitialValues = (type, offers) => {
  if (typeof offers === 'number') {
    return {
      [`${type}_opening_bid`]: offers,
      [`${type}_bid`]: null,
      [`${type}_sold`]: null
    };
  }

  return {
    [`${type}_opening_bid`]: offers?.opening_bid,
    [`${type}_bid`]: offers?.bid,
    [`${type}_sold`]: offers?.sold,
    [`${type}_fake_user_id`]: offers?.fake_user_id,
    [`${type}_checkbox`]: offers?.checked
  };
};

export const VehicleNotesPopover = ({ vehicleData, classes, afterSave }) => {
  const notesModalId = `notesModal_${vehicleData.id}`;

  const dispatch = useDispatch();
  const toggleModal = () => dispatch(modalsToggle(notesModalId));

  const ParsedInfoIcon = (() => {
    if (vehicleData.admin_finalize_notes) return successInfoIcon;
    if (vehicleData.admin_notes) return infoIcon;
    return greyInfoIcon;
  })();

  return (
    <StyledWrapper>
      <Tooltip
        disableFocusListener
        disableTouchListener
        classes={{ tooltip: classes.tooltip, popper: classes.popper }}
        title={
          vehicleData.admin_notes || vehicleData.reserve_price || vehicleData.starting_bid ? (
            <StyledGridContainer container>
              {vehicleData.admin_notes ? (
                <StyledGridItemLabel item xs={12}>
                  {vehicleData.admin_notes}
                </StyledGridItemLabel>
              ) : null}
              {vehicleData.reserve_price ? (
                <Fragment>
                  <StyledGridItem item xs={12}>
                    <FormattedAmount amount={vehicleData.reserve_price} />
                  </StyledGridItem>
                </Fragment>
              ) : null}
              {vehicleData.starting_bid ? (
                <Fragment>
                  <StyledGridItem item xs={12}>
                    <FormattedAmount amount={vehicleData.starting_bid} />
                  </StyledGridItem>
                </Fragment>
              ) : null}
            </StyledGridContainer>
          ) : (
            'Click to add notes'
          )
        }
      >
        <StyledInfoButton onClick={toggleModal}>
          <ParsedInfoIcon />
        </StyledInfoButton>
      </Tooltip>
      <NotesModal
        modalId={notesModalId}
        vehicle={vehicleData}
        afterSave={afterSave}
        initialValues={{
          adminNotes: vehicleData.admin_notes || '',
          inspectorNotes: vehicleData.inspector_notes?.message || '',
          salespersonNotes: vehicleData.salesperson_notes || '',
          inspectorPrivateNotes: vehicleData.private_inspector_notes?.message || '',
          adminFinalizeNotes: vehicleData.admin_finalize_notes || '',
          reserve_price: vehicleData.reserve_price || '',
          starting_bid: vehicleData.starting_bid ?? 100,
          alternative_offer: vehicleData.active_alternative_offer?.amount ?? '',
          ...createOtherOfferInitialValues('acv', vehicleData.other_offers?.acv),
          ...createOtherOfferInitialValues('other', vehicleData.other_offers?.other),
          ...createOtherOfferInitialValues('open_lane', vehicleData.other_offers?.open_lane)
        }}
      />
    </StyledWrapper>
  );
};

export default withStyles(styles as any)(VehicleNotesPopover);
